module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "cheers.5dde7d33.png";